(function () {
  // Function to extract Calendly URL from various formats
  function extractCalendlyUrl(url) {
    if (!url) return null;

    // If it's already a Calendly URL, return it
    if (url.includes("calendly.com")) {
      // Extract the Calendly event URL
      // Handle formats like:
      // - https://calendly.com/username/event
      // - https://calendly.com/username/event?param=value
      const match = url.match(/(https?:\/\/[^\/]+\.calendly\.com\/[^\?]+)/);
      if (match) {
        return match[1];
      }
      return url;
    }

    return null;
  }

  // Function to open Calendly popup
  function openCalendlyPopup(url) {
    if (typeof Calendly !== "undefined") {
      Calendly.initPopupWidget({
        url: url,
      });
    } else {
      // Fallback: wait for Calendly to load
      window.addEventListener("calendly.ready", function () {
        Calendly.initPopupWidget({
          url: url,
        });
      });
    }
  }

  // Initialize all meeting buttons
  function initMeetingButtons() {
    const meetingButtons = document.querySelectorAll(
      ".meeting-button, .meeting-button__mobile",
    );

    meetingButtons.forEach(function (button) {
      // Skip if already initialized
      if (button.dataset.calendlyInitialized) {
        return;
      }

      const href = button.getAttribute("href");
      const calendlyUrl = extractCalendlyUrl(href);

      if (calendlyUrl) {
        button.dataset.calendlyInitialized = "true";
        button.addEventListener("click", function (e) {
          e.preventDefault();
          openCalendlyPopup(calendlyUrl);
        });
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMeetingButtons);
  } else {
    initMeetingButtons();
  }

  // Re-initialize when new content is loaded (for dynamic content)
  const observer = new MutationObserver(function (mutations) {
    initMeetingButtons();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
